var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('div',{staticClass:"markGoodInfo"},[_c('Icon',{attrs:{"type":"md-checkmark-circle-outline"}}),_c('span',{staticClass:"tag2"},[_vm._v("病程好转")]),_c('span',{staticClass:"tag"},[_vm._v("最佳诊疗方案购买条件")]),_c('span',[_vm._v("|")]),_c('span',[_vm._v(_vm._s(_vm.date))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }